import { svgs } from "../assets/svgs"
import { tracking } from "../utils/tracking"


const cards = [
   {
      svg: svgs.power,
      name: 'Tech',
      industries: [
         'AI',
         'EdTech',
         'Mobile',
         'Internet/Digital Media',
         'IoT',
         'Robotics',
         'Security',
         'Software/IT',
      ]
   },
   {
      svg: svgs.fintech,
      name: 'Fintech',
      industries: [
         'Banking',
         'Blockchain',
         'Insurtech',
         'Payments',
         'Personal Finance',
         'Predictive Analytics',
      ]
   },
   {
      svg: svgs.leaf,
      name: 'Cleantech Climate Tech',
      industries: [
         'AgriTech',
         'Energy Efficiency',
         'Energy Generation',
         'Energy Infrastructure',
         'Energy Storage',
         'Transportation',
         'Water & Wastewater',
      ]
   },
   {
      svg: svgs.stethoscope,
      name: 'MedTech',
      industries: [
         'AI Solutions',
         'Diagnostics',
         'Medical AR',
         'Medical Devices',
         'Monitoring',
         'Wearables',
      ]
   },
   {
      svg: svgs.DNA,
      name: 'Life Sciences Healthcare',
      industries: [
         'BioTech',
         'Drug Discovery',
         'Healthcare',
         'Healthcare IT',
         'Life Sciences',
         'Pharma',
         'Telehealth',

      ]
   },
   {
      svg: svgs.seedling,
      name: 'Seed Stage',
      industries: [
         'Cleantech',
         'CPG',
         'Fintech',
         'Foodtech',
         'Healthcare',
         'Lifesciences',
         'Medtech',
         'Tech',

      ]
   },
]

export const FeaturedSectors = () => {
   return (
      <div className='featured-sectors'>
         <h1>Call for Top Innovators</h1>
         <p>
            A select group of more than <span>100 Top Innovators</span> from the following sectors will be chosen to showcase their breakthrough investment opportunities to an exclusive audience of Venture Capitalists, Corporate Investors, Private Investors, Investment Bankers, and Strategic Partners.
         </p>
         <h2>Featured Sectors</h2>
         <section className="cards-container">
            {
               cards.map((card, cardIdx) =>
                  <div key={cardIdx} className='card'>
                     {card.svg}
                     <h3>{card.name}</h3>
                     <ul>
                        {
                           card.industries.map((industry, idx) =>
                              <li key={idx}>
                                 {industry}
                              </li>
                           )
                        }
                     </ul>
                  </div>
               )
            }
         </section>
         <div className='motto'>
            <h3>Get Noticed</h3>
            {svgs.chevronRight3}
            <h3> Get Funded</h3>
            {svgs.chevronRight3}
            <h3>Grow Faster</h3>
         </div>
         {/* <a className='btn b2' href='https://account.youngstartup.com/' onClick={() => tracking(284)}>
            Apply To Present
         </a > */}
      </div>
   )
}
